{
	"withdrawCardLabel": "Importe contabilizado en las retiradas efectuados en el período",
	"advanceCardLabel": "Importe contabilizado en anticipos efectuados en el período",
	"totalLabel": "Suma de retiradas y anticipos realizados en el período"
}
